
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as aboutfK6TavJeC9N5DAxZgHx5ILQe1lRyziiOlfbKO76wzqMMeta } from "/vercel/path0/app/pages/about.vue?macro=true";
import { default as indexXNEFQ_BjAwM6CKVywW7WXWaOQOf9WzaBic0wLTXHAssMeta } from "/vercel/path0/app/pages/index.vue?macro=true";
import { default as indexXGU_kUTQuSUDXIyTGChxdSwM4YSmBQIiF0tFtKW4PP4Meta } from "/vercel/path0/app/pages/articles/index.vue?macro=true";
import { default as indexBZ7V3irGkgFOgH6021JteShbmLlP0JAp1iNlx2KNwHkMeta } from "/vercel/path0/app/pages/projects/index.vue?macro=true";
import { default as _91slug_93cBg26nLtbtxa8G32Hoa1_BuDXhBVNrVeDTZwajtDLJIMeta } from "/vercel/path0/app/pages/articles/[slug].vue?macro=true";
import { default as _91slug_93dJjjv5auBVbkCuo5N4PnbOt8U_S9XNcaEBBByls2UMMMeta } from "/vercel/path0/app/pages/projects/[slug].vue?macro=true";
export default [
  {
    name: "about",
    path: "/about",
    component: () => import("/vercel/path0/app/pages/about.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/vercel/path0/app/pages/index.vue")
  },
  {
    name: "articles",
    path: "/articles",
    component: () => import("/vercel/path0/app/pages/articles/index.vue")
  },
  {
    name: "projects",
    path: "/projects",
    component: () => import("/vercel/path0/app/pages/projects/index.vue")
  },
  {
    name: "articles-slug",
    path: "/articles/:slug()",
    component: () => import("/vercel/path0/app/pages/articles/[slug].vue")
  },
  {
    name: "projects-slug",
    path: "/projects/:slug()",
    component: () => import("/vercel/path0/app/pages/projects/[slug].vue")
  }
]